/*
 * ██████╗ ██╗████████╗███████╗ █████╗  ██████╗████████╗ ██████╗ ██████╗ ██╗   ██╗
 * ██╔══██╗██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝╚══██╔══╝██╔═══██╗██╔══██╗╚██╗ ██╔╝
 * ██████╔╝██║   ██║   █████╗  ███████║██║        ██║   ██║   ██║██████╔╝ ╚████╔╝
 * ██╔══██╗██║   ██║   ██╔══╝  ██╔══██║██║        ██║   ██║   ██║██╔══██╗  ╚██╔╝
 * ██████╔╝██║   ██║   ██║     ██║  ██║╚██████╗   ██║   ╚██████╔╝██║  ██║   ██║
 * ╚═════╝ ╚═╝   ╚═╝   ╚═╝     ╚═╝  ╚═╝ ╚═════╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝   ╚═╝
 *
 *
 * Copyright (c) Bitfactory GmbH. All rights reserved.
 * https://www.bitfactory.io
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
 * FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 * COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
 * ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

import * as React from 'react';
import { ReactElement } from 'react';
import { Button, Grid, Link, TextField, GridLegacy } from '@mui/material';
import { observer } from 'mobx-react';
import { LoginContentViewModel } from './LoginContentViewModel';
import { useViewModel } from '../../../../hooks/useViewModel';
import { LoginDialogViewStyles } from '../LoginDialogViewStyles';
import { FormattedMessage } from 'react-intl';

const LoginContentView = observer((): ReactElement => {
	const viewModel: LoginContentViewModel = useViewModel(LoginContentViewModel);

	const { classes } = LoginDialogViewStyles();

	return (
		<GridLegacy container className={classes.container}>
			<form onSubmit={(e) => viewModel.login(e)}>
				<GridLegacy container className={classes.inputContainer}>
					<GridLegacy item xs={12}>
						<label id='email' className={classes.label}>
							<FormattedMessage id={'requestAccess.e_mail'} />
						</label>
					</GridLegacy>
					<GridLegacy item xs={12}>
						<TextField
							variant='outlined'
							type='email'
							className={classes.input}
							onChange={viewModel.changeEmail}
							size='small'
							autoFocus={true}
						/>
					</GridLegacy>
				</GridLegacy>
				<GridLegacy container className={classes.inputContainer}>
					<GridLegacy item xs={12}>
						<label id='password' className={classes.label}>
							<FormattedMessage id={'requestAccess.login.password'} />
						</label>
					</GridLegacy>
					<GridLegacy item xs={12}>
						<TextField
							variant='outlined'
							type='password'
							className={classes.input}
							onChange={viewModel.changePassword}
							size='small'
						/>
					</GridLegacy>
				</GridLegacy>
				<GridLegacy container>
					<GridLegacy item xs={12} className={classes.forgotPassword}>
						<Link
							onClick={() => {
								viewModel.closeLoginPopover();
								viewModel.goToForgotPassword();
							}}>
							<FormattedMessage id={'requestAccess.login.forgot_password'} />
						</Link>
					</GridLegacy>
					<GridLegacy item xs={12}>
						<Button
							className={classes.loginButton}
							type='submit'
							variant='contained'
							color='secondary'
							disabled={viewModel.disableLoginButton()}>
							<FormattedMessage id={'requestAccess.login.login'} />
						</Button>
					</GridLegacy>
				</GridLegacy>
			</form>
		</GridLegacy>
	);
});

export default LoginContentView;
